export enum HHDSInputState {    
    Default = 'default',
    Error = 'error',
}